
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Campaign } from "@/types/campaigns";

interface DeleteCampaignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  campaign: Campaign | null;
}

const DeleteCampaignDialog = ({
  open,
  onOpenChange,
  onConfirm,
  campaign,
}: DeleteCampaignDialogProps) => {
  if (!campaign) return null;

  const getActionText = () => {
    switch (campaign.status) {
      case 'active':
        return {
          title: 'Finalizar e Excluir Campanha',
          description: `A campanha "${campaign.name}" está ativa. Ao excluí-la, suas regras serão automaticamente revertidas e a campanha será removida permanentemente.`,
          action: 'Finalizar e Excluir'
        };
      case 'scheduled':
        return {
          title: 'Cancelar Campanha Agendada',
          description: `Você tem certeza que deseja cancelar a campanha "${campaign.name}"? Esta ação não pode ser desfeita.`,
          action: 'Cancelar Campanha'
        };
      default:
        return {
          title: 'Excluir Campanha',
          description: `Você tem certeza que deseja excluir a campanha "${campaign.name}"? Esta ação não pode ser desfeita.`,
          action: 'Excluir'
        };
    }
  };

  const actionText = getActionText();

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{actionText.title}</AlertDialogTitle>
          <AlertDialogDescription>
            {actionText.description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="bg-red-600 hover:bg-red-700"
          >
            {actionText.action}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteCampaignDialog;
